import { render, staticRenderFns } from "./ProjectCategories.vue?vue&type=template&id=394a8ac8&"
import script from "./ProjectCategories.vue?vue&type=script&lang=js&"
export * from "./ProjectCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports